module.exports = __webpack_public_path__ + "img/media-console.ba50787.png";